import State from 'interfaces/state/State';

export const isLoading$ = (state: State) => state.affiliate.isLoading;
export const isError$ = (state: State) => state.affiliate.isError;
export const affiliate_url$ = (state: State) => state.affiliate.affiliate_url;
export const isErrorSendAffiliate$ = (state: State) => state.affiliate.isErrorSendAffiliate;
export const isLoadingSendAffiliate$ = (state: State) => state.affiliate.isLoadingSendAffiliate;
